import { memo } from 'react';
import ResetPassword from 'modules/v2/containers/ResetPasswordContainer';

function SetPasswordPage() {
  return <ResetPassword />;
}

export default memo(SetPasswordPage);
